const style = {
    control: {
        backgroundColor: '#fff',
        border:"none",
    },
    '&multiLine': {
        control: {
            fontFamily: 'Nunito Sans',
            minHeight: "38px",
            maxHeight: "38px",
            borderRadius: "6px",
        },
        highlighter: {
            padding: "10px 0px 10px 15px",
            overflow: "hidden",
        },
        input: {
            padding: "10px 0px 10px 15px",
            borderRadius: "6px",
            '&:focus': {
                borderColor: '#bb86fc !important',
                borderWidth: '1px !important',
                borderStyle: 'solid !important',
                outline: 'none',
            },
            '&:focus-visible': {
                borderColor: '#bb86fc',
                outline: 'none',
                border:"1px solid bb86fc !important"
            },
        },
    },
    '&singleLine': {
        display: 'inline-block',
        width: 180,
        highlighter: {
            padding: 1,
        },
        input: {
            padding: 1,
            '&:focus': {
                borderColor: '#bb86fc !important',
                borderWidth: '1px !important',
                borderStyle: 'solid !important',
                outline: 'none',
            },
            '&:focus-visible': {
                borderColor: '#bb86fc',
                outline: 'none',
                border:"1px solid bb86fc !important"
            },
        },
    },
    suggestions: {
        list: {
            backgroundColor: 'white',
            border: '1px solid rgba(0,0,0,0.15)',
            fontSize: 16,
            borderRadius: "10px",
            zIndex:1,
            maxHeight: '200px',
            overflowY: 'auto', 
        },
        item: {
            padding: '5px 15px',
            borderBottom: '1px solid rgba(0,0,0,0.15)',
            '&focused': {
                backgroundColor: '#fecb03',
            },
        },
    },
}
 export default style;